<template>
  <td class="page-cell" v-html="url"></td>
</template>

<script>
import { defaultNullHtml } from "@/js/defaultNullHtml";

export default {
  props: ["content"],
  computed: {
    url() {
      return this.content ? this.content : defaultNullHtml();
    }
  }
};
</script>

<style scoped>
.page-cell {
  max-width: 180px;
}
</style>
